import type { NavigateFunction } from 'react-router-dom';

export const openNotificationLink = (
  linkUrl: string,
  navigate: NavigateFunction,
) => {
  if (linkUrl.startsWith('/admin/')) {
    window.location.assign(linkUrl);
    return;
  }
  navigate(linkUrl);
};
